// LikeButton.js

import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart as solidHeart } from '@fortawesome/free-solid-svg-icons';
import { faHeart as regularHeart } from '@fortawesome/free-regular-svg-icons';

import firebase from "../../01-atoms/firebase/firebase";
import { getDatabase, ref, child, set, onValue, off } from 'firebase/database';

const LikeButton = (props) => {
    const { selectedProduct } = props;

    const [like, setLike] = useState(false);
    const [counter, setCounter] = useState(0);

    const database = getDatabase(firebase);
    const dbRef = ref(database, 'products');

    useEffect(() => {
        const productName = selectedProduct[0].product.fields.productName;
        const productRef = child(dbRef, productName);
        
        // Check if the product already exists in the database
        onValue(productRef, (snapshot) => {
            const product = snapshot.val();
            if (product) {
                setCounter(product.likes);
            }
        });

        // Clean up the listener
        return () => {
            off(productRef);
        };
    }, [dbRef, selectedProduct]);

    // Function to generate a unique user ID
    const generateUniqueId = () => {
        return Math.random().toString(36).substr(2, 9);
    }

    const handleClick = () => {
        setLike(!like);
        setCounter(like ? counter - 1 : counter + 1);

        // Get the unique user ID from local storage or generate a new one if not exists
        let uniqueId = localStorage.getItem('uniqueUserId');
        if (!uniqueId) {
            uniqueId = generateUniqueId();
            localStorage.setItem('uniqueUserId', uniqueId);
        }

        const productName = selectedProduct[0].product.fields.productName;
        const productData = {
            productId: selectedProduct[0].product.id,
            likes: like ? counter - 1 : counter + 1,
            userId: uniqueId
        };

        const productRef = child(dbRef, productName);

        // Update the product entry in the database or create a new one if it doesn't exist
        set(productRef, productData)
            .then(() => console.log("Product entry updated in the database"))
            .catch((error) => console.error("Error updating product entry in the database: ", error));
    };

    return (
        <div className="like-button__container">
            <FontAwesomeIcon icon={like ? solidHeart : regularHeart} title={like ? "Remove from wishlist" : "Add to wishlist"} onClick={handleClick} className={like ? 'liked' : ''}/>

            <div className="like-button__counter">
                {counter === 1 && like ? `You like this product` : counter > 1 && like ? `You & ${counter - 1} other like this product` : counter > 0 ? `${counter} other liked this product` : null}
            </div>
        </div>
    );
}

export default LikeButton;